'use client'
import { tw } from 'utils/classnames'
import * as React from 'react'

import { useContentProductStatsQuery } from '@web/gen/content'
import { HeartIcon } from '../../icons/heart'
import { EyeIcon } from '../../icons/eye'
import { DownloadIcon } from '../../icons/download-01'
import { Stat } from './stat'
import { Likes } from './likes'
import { RatingStat } from './rating'
import { DownloadsValue } from './downloads'
import { ViewsValue } from './views'

interface StatsProps extends React.HTMLAttributes<HTMLDivElement> {
  productId: string
  className?: string
  statClassName?: string
  isSticky?: boolean
}

export function Stats({ productId, statClassName, className, isSticky, ...rest }: StatsProps) {
  const { data } = useContentProductStatsQuery({ productId })

  return (
    <div data-id="prod-stats" className={tw('flex flex-row gap-4', className)} {...rest}>
      <RatingStat
        className={tw('items-end', isSticky && 'cursor-pointer items-start', statClassName)}
        productId={productId}
        data-id="prod-stat-reviews"
        hideDescription={isSticky}
        clickable={isSticky}
      />
      <div className="order-1 flex flex-row gap-2 min-[575px]:order-2">
        <Stat
          icon={<HeartIcon className="size-5" />}
          value={<Likes />}
          className={statClassName}
          data-id="prod-stat-likes"
        />
        <Stat
          icon={<EyeIcon className="size-5" />}
          value={<ViewsValue defaultTotal={data?.contentProductStats.views || 0} />}
          className={statClassName}
          data-id="prod-stats"
        />
        <Stat
          icon={<DownloadIcon className="size-5" />}
          value={<DownloadsValue defaultTotal={data?.contentProductStats.downloads || 0} />}
          className={statClassName}
          data-id="prod-stats"
        />
      </div>
    </div>
  )
}
